import { atom } from 'jotai'

/**
 * Save announcement from the floating bar's dirty controls to the output view.
 * The bar and the view are sibling mounts (the bar renders from view-registry),
 * so a persisted save signals through here and the view resets that action's
 * focus — returning the row to its resting state rather than leaving it
 * expanded. The view consumes the signal (writes null back) once handled.
 */
export const savedDraftFocusResetAtom = atom<{ actionId: string } | null>(null)
